'use client';

import {
  DialogTitle,
  DialogTitleProps,
  IconButton,
  Typography,
} from '@mui/material';

import { styled } from '../../styles';

export const StyledDialogTitle = styled(DialogTitle)<DialogTitleProps>(
  ({ theme }) => ({
    position: 'relative',
    padding: theme.spacing(6),
    textAlign: 'center',
  }),
);

export const DialogDescription = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const DialogCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
}));
